import {NavLink, useLocation} from 'react-router-dom';
import {useCallback} from 'react';

type ListItemProps = {
  route?: string,
  label: string,
  exact?: boolean,
  closeDrawer: () => void,
}

const LinkRenderer = ({
  label,
  exact = true,
  route,
  closeDrawer
}: ListItemProps) => {
  const {pathname} = useLocation();

  const handleClick = useCallback((e) => {
    if (pathname === route) return e.preventDefault();

    closeDrawer();
  }, [closeDrawer, pathname, route]);

  return (
    <NavLink
      className="link"
      activeClassName="selected cursor-default"
      exact={exact}
      to={route || '/'}
      onClick={handleClick}
    >
      {label}
    </NavLink>);
};

export default LinkRenderer;
